Namespace 'Settings.Views.Topics.Twitter'

class Settings.Views.Topics.Twitter.AccountInput extends Backbone.View
  template: JST['backbone/templates/settings/topics/twitter/account_input']

  events:
    'change input.twitter-username': '_onChange'
    'click input.account-checkbox-input': '_onClick'
    'check_twitter_username': '_onChange'
    'click .my-account-checkbox-input': '_enableAccept'
    'click .other-accounts-checkbox-input': '_disableAccept'

  initialize: (usernameInput, otherAccountInput, acceptButton) ->
    @usernameInput = usernameInput
    @otherAccountInput = otherAccountInput
    @validateUsername = new Settings.Models.Topics.Twitter.ValidateTwitterUsername()
    @acceptButton = acceptButton

  render: ->
    @$el.html(@template())
    @_setEmpty()
    @_hideInput()
    @_hideSpinner()
    @_enableAccept()
    @

  _disableAccept: ->
    @acceptButton.attr('disabled', true)
    @acceptButton.attr('title', 'The account needs to be checked');

  _enableAccept: ->
    @acceptButton.attr('disabled', false)
    @acceptButton.attr('title', '');

  _setEmpty: ->
    @$el.find('.username-validation')
      .removeClass('correct')
      .removeClass('incorrect')
      .addClass('empty')
    @_disableAccept()

  _setIncorrect: ->
    @$el.find('.username-validation').removeClass('correct empty').addClass('incorrect')
    @_disableAccept()

  _setCorrect: ->
    @$el.find('.username-validation').removeClass('incorrect empty').addClass('correct')
    @_enableAccept()

  _setOtherAccountInput: ->
    val = @$el.find('.account-checkbox-input[name="username"]:checked').val()
    isOtherAccount = val == 'other-account'
    @_toggleHideInput(isOtherAccount)
    @otherAccountInput.val(isOtherAccount)

  _onClick: ->
    @_setOtherAccountInput()

  _validateUsername: (username) ->
    @validateUsername.fetch({
      data: {username: username}
      error: (model, response, options) ->
        showError(I18n.t('monitoring.user_settings.predefined_templates.error.error_on_save'))
    })

  _toggleHideInput: (isOtherAccount) ->
    if isOtherAccount then @_showInput() else @_hideInput()

  _hideInput: ->
    @$el.find('.twitter-account-input').addClass('hidden')

  _showInput: ->
    @$el.find('.twitter-account-input').removeClass('hidden')

  _showSpinner: ->
    @$el.find('.username-validation')
      .removeClass('incorrect correct')
      .addClass('checking-listening-username')
    @$el.find('.loading-spinner').removeClass('hidden')

  _hideSpinner: ->
    @$el.find('.username-validation').removeClass('checking-listening-username')
    @$el.find('.loading-spinner').addClass('hidden')

  _onChange: ->
    @_disableAccept()
    username = @$el.find('.twitter-username').val()
    return @_setEmpty() if username == ''

    @_showSpinner()
    @_validateUsername(username)
      .complete(=>
        @_hideSpinner()
        if @validateUsername.get('username_is_valid') then @_setCorrect() else @_setIncorrect()
        @usernameInput.val(username)
        @_setOtherAccountInput()
      )
